import React, { useContext, useRef, useState } from 'react';
import { filter, find, forEach, uniq, map } from 'lodash';
import SvgIcon from "../../../../../../common/components/svg-icon";
import Http from '../../../../../../common/http';
import { checkResult, checkTimeout } from '../../../../../../express/researcher/common/summary-panel/http-helpers';
import { FocusBaseContext } from '../../../contexts';
import NoData from './noData';
import WithData from './withData';

const Index = () => {
  const { currentSummary, aiSummaries, setAiSummaries } = useContext(FocusBaseContext);

  const [ working, setWorking ] = useState(false);
  const [ disabled, setDisabled ] = useState(false);
  const [ attempt, setAttempt ] = useState(0);
  const attemptRef = useRef(attempt);
  attemptRef.current = attempt;

  const runAI = () => {
    if (working) {
      return;
    }

    setWorking(true);
    setAttempt(0);

    Http.post(
      '/express/api/ai_summaries/for_focus',
      {
        "focus_id": currentSummary.id,
        "filter": currentSummary.filter
      }
    ).then(
      (http) => {
        if (http.response.status === 200) {
          if (http.data.length > 0) {
            forEach(http.data, (record) => {
              const summary = find(aiSummaries, (el) => (el.id === record.id));

              if (summary) {
                summary.jid = record.jid;
              } else {
                aiSummaries.push(record.record);
              }
            });
            setAiSummaries([ ...aiSummaries ]);
          }

          setTimeout(() => {
            checkResult(http.data, setAttempt, attemptRef, aiSummaries, setAiSummaries, setWorking);
          }, checkTimeout);
        } else {
          setWorking(false);
        }
      },
      (reject) => {
        console.log('something went wrong', reject);
      }
    );
  };

  const onChangeAddToReport = (newChecked) => {
    setDisabled(true);
    Http.post(
      "/express/api/ai_summaries/add_to_report",
      {
        focus_id: currentSummary.id,
        add_to_report: newChecked
      }
    ).then(
      (http) => {
        if (http.response.status === 200) {
          forEach(aiSummaries, (el) => {
            el.add_to_report = newChecked;
          });
          setAiSummaries([ ...aiSummaries ]);
        }
        setDisabled(false);
      },
      (reject) => {
        console.log('something went wrong', reject);
      }
    );
  };

  const aiCnt = uniq(map(aiSummaries, (item) => item.source_id)).length;
  const checked = filter(aiSummaries, (el) => (el.add_to_report)).length === aiSummaries.length;

  return (
    <div className="summary-ai">
      <div className="summary-panel comparisons_plate -bordered -dark -js-scorecard">
        <div>
          <SvgIcon name="scheme" />
        </div>

        {!aiCnt && <NoData working={ working } runAI={ runAI } />}

        {!!aiCnt &&
          <WithData
            working={ working }
            runAI={ runAI }
            onChangeAddToReport={ onChangeAddToReport }
            aiCnt={ aiCnt }
            checked={ checked }
            disabled={ disabled }
          />
        }
      </div>
    </div>
  );
};

export default Index;
